import { api } from './client';

export interface ResolvedPackageDto {
  id: string;
  packageCode: string;
  name: string;
  type: string;
  scope: string;
  linkingMode: string;
  validFrom: string | null;
  validTo: string | null;
  resolvedAt: string;
}

export interface GetEffectivePackageParams {
  productId: string;
  machineCategoryId?: string | null;
  packageType?: string;
}

export interface GetEffectivePackageByEquipmentParams {
  equipmentId: string;
  packageType?: string;
}

export async function getEffectivePackage(
  params: GetEffectivePackageParams
): Promise<ResolvedPackageDto | null> {
  const qs = new URLSearchParams();
  qs.set('productId', params.productId);
  if (params.machineCategoryId) qs.set('machineCategoryId', params.machineCategoryId);
  if (params.packageType) qs.set('packageType', params.packageType);

  const res = await api.get<{ data: ResolvedPackageDto | null }>(
    `/package-resolver/effective?${qs.toString()}`
  );
  return res.data;
}

export async function getEffectivePackageByEquipment(
  params: GetEffectivePackageByEquipmentParams
): Promise<ResolvedPackageDto | null> {
  const qs = new URLSearchParams();
  qs.set('equipmentId', params.equipmentId);
  if (params.packageType) qs.set('packageType', params.packageType);

  const res = await api.get<{ data: ResolvedPackageDto | null }>(
    `/package-resolver/effective?${qs.toString()}`
  );
  return res.data;
}
